import { AppText } from '@/components/AppText';
import { BasicScrollView } from '@/components/BasicScrollView';
import { CustomText } from '@/components/CustomText';
import Footer from '@/components/Footer';
import Head from 'expo-router/head';
import { Platform, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Hourglass, Panel } from 'react95-native-rabbl';
import * as AppConstants from "@/utilities/AppConstants";
import { Meta } from '@/components/Meta';

export function getBasicPaneledErrorView(title: string, error: string) {
  return (
    <BasicScrollView center={true}>
      <Meta title={title} />
            
      <Panel variant='raised' elevation={4}>
        <View style={{ padding: 20, gap: 20, alignItems: 'center' }}>

          <CustomText>Error</CustomText>

          <AppText>{error}</AppText>
        </View>
      </Panel>
      
      <Footer />

    </BasicScrollView>
  );
}

export function getBasicLoadingView() {
  return (
    <SafeAreaView style={AppConstants.STYLES.flex1}>
      <View style={AppConstants.STYLES.container2}>
        <Hourglass size={AppConstants.LARGE_HOURGLASS_SIZE} />
      </View>
    </SafeAreaView>
  );
}

export function getBasicErrorView(title: string, error: string) {
  return (
    <SafeAreaView style={AppConstants.STYLES.flex1}>
      <View style={AppConstants.STYLES.container2}>
        <CustomText>{title}</CustomText>
        <AppText>{error}</AppText>
      </View>
    </SafeAreaView>
  );
}
